import * as ActionTypes from "./types"
import { toast } from "react-toastify"
import ExtractState from "../../../models/ExtractState"

const initialExtract: ExtractState = {
	downloadInProgress: false
}

function reducer(state: ExtractState = initialExtract, action: any) {
	switch (action.type) {
		case ActionTypes.EXTRACTS_FINAL_AFTER_SHUTDOWN_REQUEST:
			return {
				...state,
				downloadInProgress: true
			}
		case ActionTypes.EXTRACTS_FINAL_AFTER_SHUTDOWN_RECEIVE:
			toast.success("Sending to SFTP. Check Slack for progress")
			return {
				...state,
				downloadInProgress: false
			}
		case ActionTypes.EXTRACTS_FINAL_AFTER_SHUTDOWN_FAILURE:
			toast.error("Unable to start final extract")
			return {
				...state,
				downloadInProgress: false
			}
	}
	return state
}

export default reducer
